import { Redis } from '@upstash/redis';

// Initialize Redis client
const redis = new Redis({
  url: process.env.REACT_APP_UPSTASH_REDIS_REST_URL!,
  token: process.env.REACT_APP_UPSTASH_REDIS_REST_TOKEN!
});

export const invalidateUserRedisCache = async (userId: string): Promise<void> => {
  try {
    // console.log(userId, 'redis');
    await redis.del(`auth0User:${userId}:metadata`);
    console.log(`Redis cache invalidated for user: ${userId}`);
  } catch (error) {
    console.error('Failed to invalidate Redis cache:', error);
    throw error;
  }
};

export const refreshUserRedisCache = async (userId: string): Promise<void> => {
  return invalidateUserRedisCache(userId);
};
